import React from "react";
import PropTypes from "prop-types";

import AlertElement from "./AlertElement";
import Box from "@mui/material/Box";

/** Alert component for MuiPage
 * @param {string | object | array} alert
 * @param {string} variant
 * @return {JSX.Element}
 */
const Alert = ({ alert , variant = "standard"}) => {
    if (Array.isArray(alert)) {
        return (
            <Box sx={{ mt: "16px !important" }}>
                {alert.map((alertInput, index) => (
                    <AlertElement
                        key={alertInput.id ? `pageAlert_${alertInput.id}` : `pageAlert_${index}`}
                        id={alertInput.id ? `pageAlert_${alertInput.id}` : `pageAlert_${index}`}
                        alert={alertInput}
                        variant={variant}
                    />
                ))}
            </Box>
        );
    }

    return <AlertElement id="pageAlert_0" alert={alert} variant={variant} />;
};

Alert.propTypes = {
    alert: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.array,
    ]),
    variant: PropTypes.string,
};

export default Alert;
